"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIndex = exports.StyledWrapper = exports.StyledBooleanListItem = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledBooleanListItem = _styledComponents.default.div.withConfig({
  displayName: "BooleanListItemstyles__StyledBooleanListItem",
  componentId: "sc-5mwjqf-0"
})(["display:flex;.c-boolean-list-item-space-around-checkboxes{display:flex;padding:", " 0 0 ", ";}.c-boolean-list-item-index{padding-right:", ";}.c-boolean-list-item-space-between{margin-left:", ";}"], function (props) {
  return props.theme.space;
}, function (props) {
  return props.theme.indentMinor;
}, function (props) {
  return props.theme.space;
}, function (props) {
  return props.theme.spaceBetweenCheckboxes;
});

exports.StyledBooleanListItem = StyledBooleanListItem;

var StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "BooleanListItemstyles__StyledWrapper",
  componentId: "sc-5mwjqf-1"
})(["width:100%;"]);

exports.StyledWrapper = StyledWrapper;

var StyledIndex = _styledComponents.default.div.withConfig({
  displayName: "BooleanListItemstyles__StyledIndex",
  componentId: "sc-5mwjqf-2"
})(["width:2.5rem;"]);

exports.StyledIndex = StyledIndex;